var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photos"},_vm._l((_vm.filteredPhotos),function(photo){return _c('div',{key:photo.id,staticClass:"photo"},[_c('img',{attrs:{"src":photo.path,"alt":""}}),_c('div',[_vm._v(_vm._s(photo.title))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }